import * as amplitude from '@amplitude/analytics-browser';

const { hostname } = window.location;
// NOTE: pre-existing — destructured from window.location where userAgent doesn't exist
// (always undefined at runtime). Kept for behavior parity.
const { userAgent } = window.location as Location & { userAgent?: string };
const isProd = hostname === 'webapp.everydoggy.com';

const PROD_KEY = '5c11432422c7701ad489cd6f279bfa65';
const DEV_KEY = 'e61ae44b1ed70b865138a73e27cefd50';

const API_KEY = isProd ? PROD_KEY : DEV_KEY;

window.earlyErrors = window.earlyErrors || [];
window.ampInited = window.ampInited || false;

function pushAmplitudeError(reason: string, error?: unknown): void {
  window.earlyErrors?.push({
    type: 'AmplitudeInitError',
    reason,
    hostname,
    apiKey: API_KEY,
    userAgent,
    timestamp: Date.now(),
    error: error ? String(error) : undefined,
  });

  window.dispatchEvent(
    new CustomEvent('early-error', {
      detail: { reason, error },
    }),
  );
}

export function initAmplitude(): void {
  if (window.ampInited) {
    return;
  }

  window.ampInited = true;

  try {
    amplitude.init(API_KEY, {
      fetchRemoteConfig: true,
      autocapture: {
        pageUrlEnrichment: true,
        elementInteractions: false,
        attribution: {
          excludeReferrers: ['everydoggy.com'],
        },
      },
    });

    // expose globally (GTM / legacy compatibility)
    window.amplitude = amplitude;

    amplitude.track('page_view');

    const identify = new amplitude.Identify().set('user_agent', userAgent as string);

    amplitude.identify(identify);

    console.log(
      '[Amplitude] Initialized →',
      isProd ? 'PROD' : 'DEV',
    );
  } catch (err) {
    pushAmplitudeError('init_exception', err);
  }
}

export { amplitude };
